/*!
 *  (c)(r) 2008-2025 IT-Service Robert Frunzke
 */

import { MPlugins, mj, FireOnceCallbackList } from 'js/entry/util.js';
import { $ } from 'js/entry/base.js';

import { queryCachedInquirerVoting } from './inquirer_voting.js';
import { queryCachedApproverVotes } from './approver_votes.js';

import { onInquirerResultViewSelectionChanged, onInquirerResultViewNodesLoaded } from './inquirer-result-view.js';
import { onApproverResultViewSelectionChanged, onApproverResultViewNodesLoaded } from './approver-result-view.js';
import { MVMediaPage } from 'js/entry/media.js';

/**
 *
 */
MPlugins.register( [$,mj], 'ui-votings-result-view-hooks', function($,mj) {
	var m_focl = null;

	return {
		type: 'MediaResultView',

		beforeUpdateResult: function( $result_elem, list_type, object_id, object_item ) {
			m_focl = null;
			MVMediaPage.contextMenuDynamicContent(null);

			if( list_type!=='lightbox' || object_item===null || (object_item.x_plugin||null)==null ) {
				return;
			}

			$result_elem.attr('data-xext','votings');

			m_focl = new FireOnceCallbackList;
			const voting_id = object_item.x_id || 0;
			const user_is_owner_of_lb = mj.user_id==object_item.owner_id;
			if( user_is_owner_of_lb ) {
				queryCachedInquirerVoting( voting_id, function( inquirer_voting ) {
					if( m_focl ) {
						m_focl.fire( $result_elem, object_id, object_item, user_is_owner_of_lb, {
							inquirer_voting
						} );
					}
				} );
			} else {
				queryCachedApproverVotes(
					voting_id,
					function( av_changed_dt, av_submitted_dt, approver_votes, media_ids ) {
						if( m_focl ) {
							m_focl.fire( $result_elem, object_id, object_item, user_is_owner_of_lb, {
								av_changed_dt,
								av_submitted_dt,
								approver_votes,
								media_ids
							} );
						}
					},
					function( jqXHR, textStatus, message ) {
						//TODO
						//console.log(textStatus);
					}
				);
			}
		},

		resultNodesLoaded: function( loaded_media_ids ) {
			if( m_focl===null ) {
				return;
			}
			m_focl.add( function( $result_elem, object_id, object_item, user_is_owner_of_lb, obj ) {
				// console.log({w:'resultNodesLoaded focl',$result_elem, object_id, object_item, user_is_owner_of_lb,obj,loaded_media_ids});
				if( user_is_owner_of_lb ) {
					onInquirerResultViewNodesLoaded($result_elem,object_id,object_item,obj.inquirer_voting,loaded_media_ids);
				} else {
					onApproverResultViewNodesLoaded($result_elem,object_id,object_item,obj.av_changed_dt,obj.av_submitted_dt,obj.approver_votes,obj.media_ids,loaded_media_ids);
				}
			} );
		},

		selectionChanged: function( sel_actually_changed, sel_media_ids ) {
			if( m_focl===null ) {
				return;
			}
			// skip when selection did not change actually
			if( !sel_actually_changed ) {
				return;
			}
			MVMediaPage.contextMenuDynamicContent(null);
			m_focl.add( function( $result_elem, object_id, object_item, user_is_owner_of_lb, obj ) {
				// console.log({w:'selectionChanged focl',$result_elem, object_id, object_item, user_is_owner_of_lb, obj, sel_media_ids });
				if( user_is_owner_of_lb ) {
					onInquirerResultViewSelectionChanged($result_elem,object_id,object_item,obj.inquirer_voting,sel_media_ids);
				} else {
					onApproverResultViewSelectionChanged($result_elem,object_id,object_item,obj.av_changed_dt,obj.av_submitted_dt,obj.approver_votes,obj.media_ids,sel_media_ids);
				}
			} );
		}
	};
} );
